export class SiteSummary {
  siteTitle: string;
  cityProvinceCountry: string;
  phoneNumber: string;
}
